// @mui
import { styled } from '@mui/material/styles';
import { ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
// config
import { ICON } from '../../../config';

// ----------------------------------------------------------------------

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.subtitle1,
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  minHeight: 56,
  textTransform: 'none',
  paddingLeft: theme.spacing(1.75),
  paddingRight: theme.spacing(1.5),
  marginBottom: theme.spacing(1.25),
  color: 'rgba(255,255,255,0.92)',
  borderRadius: 20,
  backgroundColor: 'rgba(255,255,255,0.10)',
  backdropFilter: 'blur(10px)',
  transition: theme.transitions.create(['background-color', 'transform', 'box-shadow'], {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.16)',
    transform: 'translateY(-1px)',
  },
  ...(activeRoot && {
    color: '#FFFFFF',
    backgroundColor: '#94CF63',
    boxShadow: '0 14px 30px rgba(148, 207, 99, 0.28)',
    '&:hover': {
      backgroundColor: '#94CF63',
    },
    '& .MuiListItemIcon-root': {
      color: '#FFFFFF',
    },
  }),
  ...(activeSub && {
    color: '#FFFFFF',
  }),
  ...(subItem && {
    minHeight: 44,
    marginBottom: theme.spacing(0.75),
    paddingLeft: theme.spacing(2),
    borderRadius: 16,
    backgroundColor: 'transparent',
    color: 'rgba(255,255,255,0.7)',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.08)',
      transform: 'none',
    },
    ...(activeSub && {
      backgroundColor: 'rgba(148, 207, 99, 0.16)',
      color: '#FFFFFF',
    }),
  }),
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})(({ isCollapse, theme }) => ({
  flex: '1 1 auto',
  minWidth: 0,
  whiteSpace: 'nowrap',
  margin: 0,
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: 24,
  height: 24,
  minWidth: 24,
  marginRight: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#FFFFFF',
  '& svg, & img': { width: '100%', height: '100%' },
});
